import antd_tr_TR from "antd/locale/tr_TR";
import antd_en_US from "antd/locale/en_US";
import { Locale } from "antd/lib/locale";
import { LanguageKey } from "~/types/language";

export const DEFAULT_LOCALE: LanguageKey = "en-US";

export const ANTD_LOCALE: Record<LanguageKey, Locale> = {
  "tr-TR": antd_tr_TR,
  "en-US": antd_en_US,
};

export const MOMENT_LOCALE: Record<LanguageKey, string> = {
  "tr-TR": "tr",
  "en-US": "en-gb",
};

export const LANGUAGES: {
  key: LanguageKey;
  title: string;
  flag: string;
}[] = [
  {
    key: "en-US",
    title: "English",
    flag: "/images/flags/us.png",
  },
  // {
  //   key: "tr-TR",
  //   title: "Türkçe",
  //   flag: "/images/flags/tr.png",
  // },
];
